// extracted by mini-css-extract-plugin
export var footer = "_p3-0";
export var inherit = "_p3-1";
export var input = "_p3-2";
export var modalContent = "_p3-3";
export var quillEditor = "_p3-4";
export var subtitle = "_p3-5";